import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-107e8cb6"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "slider slider-product"
};
const _hoisted_2 = {
  class: "container"
};
const _hoisted_3 = {
  class: "slider__inner"
};
const _hoisted_4 = {
  class: "swiper-object"
};
const _hoisted_5 = {
  class: "slider-slide__wrapper"
};
const _hoisted_6 = {
  class: "slider-slide__content"
};
const _hoisted_7 = {
  class: "slider-slide__title"
};
const _hoisted_8 = {
  class: "slider-slide__text"
};
const _hoisted_9 = {
  class: "slider-slide__box"
};
const _hoisted_10 = ["onClick"];
const _hoisted_11 = {
  class: "slider-slide__price"
};
const _hoisted_12 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "грн", -1));
const _hoisted_13 = {
  class: "slider-slide__wrapperimg"
};
const _hoisted_14 = ["src"];
const _hoisted_15 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "slider-slide__tag"
}, "Лучшее предложение недели!", -1));
const _hoisted_16 = {
  ref: "pagination",
  class: "swiper-pagination"
};
const _hoisted_17 = {
  class: "navigation"
};
const _hoisted_18 = {
  ref: "prev",
  class: "swiper-button-prev"
};
const _hoisted_19 = {
  ref: "next",
  class: "swiper-button-next"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_swiper_slide = _resolveComponent("swiper-slide");
  const _component_swiper = _resolveComponent("swiper");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("div", _hoisted_3, [_createElementVNode("div", _hoisted_4, [_createVNode(_component_swiper, {
    class: "slider-box",
    modules: $setup.modules,
    pagination: {
      el: $setup.pagination,
      clickable: true
    },
    "slides-per-view": 1,
    "space-between": 40,
    navigation: {
      prevEl: $setup.prev,
      nextEl: $setup.next
    }
  }, {
    default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList($props.slides, item => {
      return _openBlock(), _createBlock(_component_swiper_slide, {
        key: item.id,
        class: "slider-slide"
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("h1", _hoisted_7, _toDisplayString(item.title), 1), _createElementVNode("p", _hoisted_8, _toDisplayString(item.composition), 1), _createElementVNode("div", _hoisted_9, [_createElementVNode("button", {
          onClick: $event => _ctx.$emit('sliderAddCart', item),
          class: _normalizeClass(["slider-slide__btn", {
            'is-checked': item.isAdded
          }])
        }, "В корзину", 10, _hoisted_10), _createElementVNode("p", _hoisted_11, [_createTextVNode(_toDisplayString(item.price), 1), _hoisted_12])])])]), _createElementVNode("div", _hoisted_13, [_createElementVNode("img", {
          class: "slider-slide__img",
          src: require(`@/img/slider/${item.imgUrl}`),
          alt: "slide"
        }, null, 8, _hoisted_14)]), _hoisted_15]),
        _: 2
      }, 1024);
    }), 128))]),
    _: 1
  }, 8, ["modules", "pagination", "navigation"]), _createElementVNode("div", _hoisted_16, null, 512), _createElementVNode("div", _hoisted_17, [_createElementVNode("div", _hoisted_18, null, 512), _createElementVNode("div", _hoisted_19, null, 512)])])])])]);
}